import React from 'react';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    num: '1',
    title: 'Banco de 100 Ejercicios de Automatización Resueltos',
    desc: '100 ejercicios de lógica de control aplicada: circuitos Ladder, temporización, conteo, enclavamientos y secuencias con PLC. Cada ejercicio incluye enunciado, solución comentada y criterio de evaluación.',
    value: '$12.000'
  }, {
    num: '2',
    title: 'Kit de Diagramas y Esquemas Industriales',
    desc: 'Los planos que tus alumnos van a usar todo el año Láminas con los 80 diagramas más utilizados en automatización industrial: circuitos de mando, diagramas de flujo de proceso, esquemas de conexionado de PLC y simbología normalizada IEC.',
    value: '$8.500'
  }, {
    num: '3',
    title: 'Guía de Simulaciones de Procesos Industriales',
    desc: 'Lo que el taller sin presupuesto necesita para enseñar PLC igual Guía paso a paso para simular 15 procesos industriales completos usando software gratuito (Factory I/O, LOGO!Soft, TIA Portal Trial). El alumno programa y prueba sin necesitar el hardware físico.',
    value: '$9.500'
  }, {
    num: '4',
    title: 'Rúbricas de Evaluación de Taller',
    desc: 'Terminá con el "pero profe, ¿por qué me pusiste esa nota?" Rúbricas completas para evaluar el desempeño práctico del alumno en taller de automatización: conexionado, programación, resolución de fallas y documentación técnica.',
    value: '$6.000'
  }];
  return <section className="py-10 md:py-16 px-4 bg-brand-dark border-y border-brand-accent/20" data-id="element-18">
      <div className="max-w-4xl mx-auto" data-id="element-19">
        <div className="text-center mb-8" data-id="element-20">
          <h2 className="text-2xl md:text-4xl font-black text-white" data-id="element-21">
            🎁 4 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-base md:text-lg text-gray-400 mt-2" data-id="element-22">
            Recursos que completan tu arsenal docente
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-8" data-id="element-23">
          {bonuses.map((bonus, i) => <div key={i} className="bg-brand-card rounded-xl p-5 border border-white/10 hover:border-brand-accent/30 transition-colors relative overflow-hidden group" data-id="element-24">
              <div className="absolute -right-4 -top-4 w-20 h-20 bg-brand-accent/10 rounded-full group-hover:scale-150 transition-transform duration-500" data-id="element-25"></div>

              <div className="flex items-start mb-3 relative z-10" data-id="element-26">
                <div className="bg-brand-accent text-black font-black text-lg w-10 h-10 rounded-lg flex items-center justify-center mr-3 shrink-0" data-id="element-27">
                  {bonus.num}
                </div>
                <div data-id="element-28">
                  <div className="flex items-center gap-1.5 mb-0.5" data-id="element-29">
                    <Gift className="w-3.5 h-3.5 text-brand-accent" data-id="element-30" />
                    <span className="text-brand-accent font-bold text-xs tracking-widest uppercase" data-id="element-31">
                      BONO {bonus.num}
                    </span>
                  </div>
                  <h3 className="text-lg font-bold leading-tight text-white" data-id="element-32">
                    {bonus.title}
                  </h3>
                </div>
              </div>

              <p className="text-sm text-gray-400 relative z-10 mb-2" data-id="element-33">
                {bonus.desc}
              </p>

              <p className="text-xs text-gray-600 relative z-10" data-id="element-34">
                Valor real:{' '}
                <span className="line-through" data-id="element-35">{bonus.value} ARS</span> —{' '}
                <span className="text-brand-accent font-bold" data-id="element-36">
                  HOY GRATIS con tu Kit
                </span>
              </p>
            </div>)}
        </div>

        <div className="bg-brand-card rounded-xl p-4 text-center border border-brand-accent/20 max-w-xl mx-auto" data-id="element-37">
          <p className="text-lg md:text-xl font-medium text-gray-300" data-id="element-38">
            💰 Valor total bonos:{' '}
            <span className="line-through text-gray-600" data-id="element-39">$36.000 ARS</span>
            <br data-id="element-40" />
            <span className="text-brand-accent font-black neon-glow text-2xl" data-id="element-41">
              👉 HOY GRATIS con tu Kit
            </span>
          </p>
        </div>
      </div>
    </section>;
}